<!-- Modal Acuerdo Indirecto-->
<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <h3 class="modal-title font">Nuevo acuerdo indirecto</h3>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <!-- Formulario Acuerdo Indirecto -->
    <form class="form-modal py-3" [formGroup]="dataForm">
      <div class="title-group">Datos del acuerdo</div>
      <!-- Campo 1: Documento + botón búsqueda -->
      <div class="row form">
        <div class="col-sm d-flex align-items-end gap-2">
          <div class="flex-grow-1">
            <label for="documento">Documento (DNI / NIF / NIE) <span class="oblig">*</span></label>
            <div class="custom-mat-field">
              <mat-form-field class="custom-mat-form-field-width" appearance="outline">
                <input type="text" matInput formControlName="documento" id="documento"
                  placeholder="Introduce el documento" maxlength="15"
                  oninput="this.value = this.value.toUpperCase()">
                <mat-error *ngIf="controlHasError('documento', 'required')">Campo obligatorio</mat-error>
                <mat-error *ngIf="!controlHasError('documento', 'required') && controlHasError('documento', 'invalidFormat')">Formato incorrecto</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <button type="button" class="btn btn-primary btn-search" [disabled]="!canBuscarGestores()" (click)="buscarGestores()">
              Buscar
            </button>
          </div>
        </div>
      </div>

      <!-- Campo 2: Desplegable de gestores (bloqueado hasta búsqueda) -->
      <div class="row form">
        <div class="col-sm">
          <label for="gestor">Gestor <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field-width" appearance="outline">
              <mat-select formControlName="gestor" id="gestor" placeholder="-- Seleccione un gestor --" multiple
                [disabled]="!searchDone" (selectionChange)="onGestorSeleccionado($event.value)">
                <mat-option *ngFor="let g of gestoresArray" [value]="g">
                  {{ g.nima }} - {{ g.razonSocial }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="controlHasError('gestor', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Campo 3: Razón social -->
      <div class="row form">
        <div class="col-sm">
          <label for="razonSocial">Razón social <span class="oblig">*</span></label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field-width" appearance="outline">
              <input type="text" matInput formControlName="razonSocial" id="razonSocial"
                placeholder="Razón social" maxlength="150">
              <mat-error *ngIf="controlHasError('razonSocial', 'required')">Campo obligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <!-- FIN Formulario Acuerdo Indirecto -->
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note">* Campos Obligatorios</div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Cancelar</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="guardar()">Guardar</button>
      </div>
    </div>
  </div>

</div>
